import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import UniqueId from 'vue-unique-id'
import VSwitch from 'v-switch-case'
import axios from 'axios'
import firebaseApp from './components/firebaseInit'
import VueLoading from 'vuejs-loading-plugin'
import firebase from 'firebase'

// NOTE no se si funcione jeje
//si jalo jeje
import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

// using default options
Vue.use(VueLoading)

library.add(fas, far, fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false
Vue.use(VSwitch)
Vue.use(UniqueId)
Vue.prototype.$axios = axios
// Vue.prototype.$esBuro = null

let app

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,
      firebaseApp,
      render: h => h(App)
    }).$mount('#app')
  }
})
